import React, { useState } from 'react';
import { Spin, Alert } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import { useH311Query } from './hooks/useH311Query';
import QueryParams from './components/QueryParams';
import ResultTable from './components/ResultTable';
import type { QueryRequest } from '../../services/h311Api';

const H311Form: React.FC = () => {
  const { loading, result, queried, noData, runQuery } = useH311Query();

  // Filter state (BR-D01 ~ BR-D10)
  const [dateFrom, setDateFrom] = useState<Dayjs | null>(null);
  const [dateTo, setDateTo] = useState<Dayjs | null>(dayjs());
  const [docNoFrom, setDocNoFrom] = useState('');
  const [docNoTo, setDocNoTo] = useState('');
  const [deptFrom, setDeptFrom] = useState('');
  const [deptTo, setDeptTo] = useState('');
  const [vendorFrom, setVendorFrom] = useState('');
  const [vendorTo, setVendorTo] = useState('');
  const [needFrom, setNeedFrom] = useState<Dayjs | null>(null);
  const [needTo, setNeedTo] = useState<Dayjs | null>(dayjs());
  const [chkDate1From, setChkDate1From] = useState<Dayjs | null>(null);
  const [chkDate1To, setChkDate1To] = useState<Dayjs | null>(dayjs());
  const [chkDate2From, setChkDate2From] = useState<Dayjs | null>(null);
  const [chkDate2To, setChkDate2To] = useState<Dayjs | null>(dayjs());
  const [entryEmpFrom, setEntryEmpFrom] = useState('');
  const [entryEmpTo, setEntryEmpTo] = useState('');
  const [approvalStatus, setApprovalStatus] = useState(4); // BR-D09: default all
  const [reportTypes, setReportTypes] = useState<string[]>([]); // BR-D10: none checked

  const fmtDate = (d: Dayjs | null): string | null =>
    d ? d.format('YYYY-MM-DD') : null;

  const handleQuery = () => {
    const sortBy = reportTypes.length > 0 ? reportTypes[0] : 'date';
    const req: QueryRequest = {
      dateFrom: fmtDate(dateFrom),
      dateTo: fmtDate(dateTo),
      docNoFrom: docNoFrom.trim(),
      docNoTo: docNoTo.trim() || 'zzzzzz',
      deptFrom: deptFrom.trim(),
      deptTo: deptTo.trim() || 'zzzz',
      vendorFrom: vendorFrom.trim(),
      vendorTo: vendorTo.trim(),
      needFrom: fmtDate(needFrom),
      needTo: fmtDate(needTo),
      chkDate1From: fmtDate(chkDate1From),
      chkDate1To: fmtDate(chkDate1To),
      chkDate2From: fmtDate(chkDate2From),
      chkDate2To: fmtDate(chkDate2To),
      entryEmpFrom: entryEmpFrom.trim(),
      entryEmpTo: entryEmpTo.trim() || 'zzzzzzzz',
      approvalStatus,
      reportTypes,
      sortBy,
    };
    runQuery(req);
  };

  return (
    <Spin spinning={loading}>
      <div className="max-w-7xl mx-auto p-4">
        <h2 className="text-xl font-bold mb-4">
          請款明細表 (pwh311f1)
        </h2>

        <QueryParams
          dateFrom={dateFrom} dateTo={dateTo}
          docNoFrom={docNoFrom} docNoTo={docNoTo}
          deptFrom={deptFrom} deptTo={deptTo}
          vendorFrom={vendorFrom} vendorTo={vendorTo}
          needFrom={needFrom} needTo={needTo}
          chkDate1From={chkDate1From} chkDate1To={chkDate1To}
          chkDate2From={chkDate2From} chkDate2To={chkDate2To}
          entryEmpFrom={entryEmpFrom} entryEmpTo={entryEmpTo}
          approvalStatus={approvalStatus}
          reportTypes={reportTypes}
          loading={loading}
          onDateFromChange={setDateFrom}
          onDateToChange={setDateTo}
          onDocNoFromChange={setDocNoFrom}
          onDocNoToChange={setDocNoTo}
          onDeptFromChange={setDeptFrom}
          onDeptToChange={setDeptTo}
          onVendorFromChange={setVendorFrom}
          onVendorToChange={setVendorTo}
          onNeedFromChange={setNeedFrom}
          onNeedToChange={setNeedTo}
          onChkDate1FromChange={setChkDate1From}
          onChkDate1ToChange={setChkDate1To}
          onChkDate2FromChange={setChkDate2From}
          onChkDate2ToChange={setChkDate2To}
          onEntryEmpFromChange={setEntryEmpFrom}
          onEntryEmpToChange={setEntryEmpTo}
          onApprovalStatusChange={setApprovalStatus}
          onReportTypesChange={setReportTypes}
          onQuery={handleQuery}
        />

        {queried && !noData && result && (
          <ResultTable result={result} />
        )}

        {queried && noData && (
          <Alert
            message="查無此資料"
            description="查無符合條件的請款資料！請確認篩選條件是否正確。"
            type="info"
            showIcon
          />
        )}
      </div>
    </Spin>
  );
};

export default H311Form;
